import * as React from 'react';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { Header } from '@app/components/Header/Header';
import { Footer } from '@app/components/Footer/Footer';
import { Chat } from '@app/components/Chat/Chat';
import { CookiesAlert } from '@app/components/CookiesAlert/CookiesAlert';
import { useAoTracker } from '@app/hooks/useAoTracker';
import { SubscribeNotification } from '@app/objects/Subscribe';
import { BurgerContext } from '@app/services/contexts';

interface LayoutProps {
	children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = (props: LayoutProps) => {
	useAoTracker(); // Needs to be placed under <Router />
	const [isShowBurger, setIsShowBurger] = React.useState<boolean>(false);
	const [isShowSubscribeForm, setIsShowSubscribeForm] = React.useState<boolean>(false);
	const [alert, setAlert] = React.useState<SubscribeNotification | undefined>(undefined);

	const burgerContext = React.useMemo(() => {
		return {
			isShowBurger,
			toggleShowBurger: setIsShowBurger,
			isShowSubscribeForm,
			toggleShowSubscribeForm: setIsShowSubscribeForm,
			alert,
			changeAlert: setAlert,
		};
	}, [
		isShowBurger,
		isShowSubscribeForm,
		alert,
	]);

	return (
		<GoogleReCaptchaProvider reCaptchaKey={process.env.app.recaptchaKey}>
			<BurgerContext.Provider value={burgerContext}>
				<Header />
				{props.children}
				<Footer />
				<Chat />
				<CookiesAlert />
			</BurgerContext.Provider>
		</GoogleReCaptchaProvider>
	);
};
